import { companyListES } from 'src/app/modules/company-list/company-list';
import { statisticsES } from 'src/app/modules/company-list/general-statistics/statitics';
import { docFormationES } from 'src/app/modules/company-view/doc-formation/doc-formation';
import { expirationStudioES } from 'src/app/modules/expirations/expiration-list/expiration';
import { IndividualsES } from 'src/app/modules/individuals/individuals';
import { ShareInfoTableES } from 'src/app/modules/information-shared/information-shared.model';
import { PowersES } from 'src/app/modules/powers-upload/powers-upload';
import {
  ActionTypeChileES,
  ActionTypeES,
  CountriesEs,
  DocumentTypeEs,
  ExpirationRangeEs,
  ExpirationTypeEs,
  POAStausEs,
  POATypeEs,
  PowerTypeEs,
  RolePersonEs,
  ShareInfoEs,
  TratamientoES,
  UserTypeEs,
} from 'src/app/modules/shared/combos-lang';
import { userMenuES } from 'src/app/pages/layout/navbar/models/profile-options';

export const Spanish = {
  lang: 'ES',
  data: {
    INDV: IndividualsES,
    USER_MENU: userMenuES,
    COUNTRIES: CountriesEs,
    EXPIRATIONRANGE: ExpirationRangeEs,
    EXPIRATIONTYPE: ExpirationTypeEs,
    POASTATUS: POAStausEs,
    POATYPE: POATypeEs,
    SHAREINFO: ShareInfoEs,
    ROLEPERSON: RolePersonEs,
    DOCUMENTTYPE: DocumentTypeEs,
    USERTYPE: UserTypeEs,
    POWERTYPE: PowerTypeEs,
    POWERS: PowersES,
    STATS: statisticsES,
    TRATAMIENTO: TratamientoES,
    ACTIONTYPE: ActionTypeES,
    ACTIONTYPECHILE: ActionTypeChileES,
    TITLES: {
      COMPANIES: 'Sociedades',
      FOLLOWERS: 'Seguidores',
      ORIGIN_COUNTRY: 'País de origen',
      SHARE_INFO: 'Compartir Información',
      LIBRARY: 'Biblioteca',
      EXPIRATIONS: 'Vencimientos',
      USERS: 'Usuarios',
      LOGS: 'Listado de Logs',
      PERSONS: 'Personas',
      PROFILE: 'Perfil',
      SOC_ADMIN: 'Administración de sociedades',
      MY_GROUPS: 'Mis Grupos',
      GROUP: 'Grupo',
      COMITES: 'Comités',
    },
    CAPITAL: {
      SOCIAL: 'Capital Social',
      SUBS: 'Capital Social Suscrito',
      NOM_VALUE: 'Valor nominal',
      NOM_VALUE_TODAY: 'Valor nominal actual',
      SHARES: 'Acciones',
      SOCIAL_Q: 'Cuotas Sociales',
      TOTAL_CAPITAL_STOCK: 'Capital Social Total',
      FIXED_CAP: 'Capital Social Fijo',
      VARIABLE: 'Capital Social Variable',
      INT: 'Capital Social Integrado',
      CURRENCY_TYPE: 'Tipo de moneda',
      OVERVIEW: 'Resumen',
      AUTHORIZED: 'Capital Autorizado',
      INTEGRATED: 'Capital Integrado',
      AVAILABLE: 'Disponible',
      PARTICIPATION: 'Participación',
    },
    TABS: {
      GENERAL_INFO: 'Información general',
      EXPIRATIONS: 'Vencimientos',
      POWERS: 'Poderes',
      POWERS_MX: 'Poderes',
      STATUTE: 'Estatuto',
      STATUTES: 'Estatutos',
      DOCS: 'Formation documents',
      MAP: 'Mapa Societario',
      BALANCES: 'Balances',
      CONTRATOS: 'Contratos',
      SHAREHOLDERS: 'Accionistas y capital social',
      PARTNERS: 'Socios y capital social',
      MEMBERS: 'Miembros',
      SUBJECTS: 'Sujetos',
      AUTHORITIES: 'Autoridades',
      DIRECTORY_REP: 'Directorio y Representantes legales',
      DIRECTORY: 'Directorio',
      MANAGMENT: 'Gerencia',
      ADMIN_REP: 'Administración y Representantes',
      ASSETS_PROVIDED: 'Bienes aportados',
      MINUTES: 'Actas y Resoluciones diversas',
      COMITES: 'Comités',
    },
    LINKED_INDEX: {
      TITLE: 'Índice de Documentos Vinculados',
      TOOLTIP: 'Índice de Documentos Vinculados',
      CLOSE: 'Cerrar',
      LOADING: 'Cargando documentos…',
      DOCUMENTS: 'documentos',
      NO_DOCUMENTS: 'sin documentos',
      SEARCH_PLACEHOLDER: 'Buscar documento…',
      EMPTY_TITLE: 'Esta sociedad no tiene documentos vinculados',
      EMPTY_SUBTITLE: 'Los documentos aparecen acá cuando se vinculan desde cada solapa.',
      NO_RESULTS: 'No se encontraron documentos',
      VIEW: 'Ver',
      DOWNLOAD: 'Descargar',
      GO_TO_TAB: 'Ir a la solapa',
      OF: 'de',
      VIEW_ALL: 'Ver todos en la solapa {{tab}}',
      ROLE_HINT: 'Ves y descargás solo lo que tu rol permite en cada módulo.',
    },
    UBICATION: {
      POSTAL_CODE: 'Codigo postal',
      JURISDICTION: 'Jurisdicción',
      COUNTRY: 'Pais',
      FLOOR: 'Piso',
      OFFICE_NUMBER: 'No. de oficina',
    },
    WIZARD: {
      DURATION_EXCERCISE: 'Duración y Ejercicio',
      DURATION_TERM: 'Plazo de duración',
      DURATION_TERM_COMPANY: 'Plazo de duración de la sociedad',
      YEAR_CLOSING: 'Cierre de ejercicio',
      ADDRESS: 'Domicilio',
      BYLAW: 'Estatuto',
      BYLAWS: 'Estatutos',
      BYLAW_MX: 'Escritura Constitutiva y Modificaciones',
      CAPITAL_STOCK: 'Capital social',
      AMOUNT_SHARE: 'Acciones',
      TYPE_SHARE: 'Tipo de acciones',
      NOMINAL_VALUE: 'Valor nominal',
      OBJECT: 'Objeto',
      MAX_AMOUNT: 'Cantidad máxima',
      MIN_AMOUNT: 'Cantidad mínima',
      INDEF_TERM: 'Plazo indefinido',
      SUB_CAPITAL_STOCK: 'Capital social suscripto',
      INT_CAPITAL_STOCK: 'Capital social integrado',
      CAP_STOCK_AND_SHARES: 'Capital Social y Acciones',
      ADDRESS_AND_HEAD: 'Domicilio y Sede',
      ADDRESS_2: 'Dirección',
      DOOR: 'No. de puerta',
      APARTMENT: 'No. de Apartamento',
      HEADQUARTERS: 'Sede',
      HEAD_MUST_BE: 'La sede debe estar dentro del domicilio',
      OFFICE_TERM: 'Plazo de duración de los cargos',
      DIRECTORY: 'Directorio',
      MANAGERS: 'Gerencia',
      ADMIN: 'Administración',
      NO_INFO: 'No contiene información',
      AMOUNT_DIRECTORS: 'Cantidad Directores titulares',
      DIRECTORS_SUP: 'Directores suplentes',
      DIRECTORS_TIT: 'Directores titulares',
      MANAGERS_SUP: 'Gerentes suplentes',
      MANAGERS_TIT: 'Gerentes titulares',
      ADMINS_TIT: 'Administradores titulares',
      ADMINS_SUP: 'Administradores suplentes',
      AUTHORITIES_TIT: 'Autoridades titulares',
      AUTHORITIES_SUP: 'Autoridades suplentes',
      AMOUNT_DIRECTORS_SUP: 'Cantidad Directores suplentes',
      SOCIAL_QUOTAS: 'Cuotas sociales',
      INDET_MANAGERS_TIT: 'Cantidad indeterminada de gerentes titulares',
      INDET_MANAGERS_SUP: 'Cantidad indeterminada de gerentes suplentes',
      PUBLIC_REGISTRY: 'Número de Registro en Registro Público de Comercio',
    },
    LABELS: {
      DOC_DETAILS: 'Detalles del documento',
      DOC_SHARE: 'Compartir documento',
      SHARE_TO: 'Compartido a',
      ACTIVE: 'Activas',
      INACTIVE: 'Desactivadas',
      ALL: 'Todas',
      FOLDER_NAME: 'Nombre de la carpeta',
      RENAME: 'Cambiar Nombre',
      SELECT_FOLDER: 'Seleccionar Carpeta',
      DOC_DATE: 'Fecha del documento',
      DOC_CONTENT: 'Contenido de documento',
      AMOUNT_SHARE: 'Acciones',
      COMPANY_NAME: 'Nombre de la Sociedad',
      COMPANY_TYPE: 'Tipo de Sociedad',
      CORPORATE_DATA_CONTROL: 'Control de Datos Societarios',
      DOC_TYPE: 'Tipo de documento',
      DOC_NAME: 'Nombre del documento',
      PROCEDURE_TYPE: 'Tipo de trámite',
      PROCESS_NUM: 'Número de trámite',
      SELECT_DOCS: 'Seleccionar Documento(s)',
      SELECT_DOC: 'Seleccionar Documento',
      SELECT_PROCEDURES: 'Select procedure type',
      STATUS: 'Estado',
      VERIFICATION_STATUS: 'Estado de Verificación',
      VERIFIED: 'Verificadas',
      NOTVERIFIED: 'No verificadas',
      VERIFIED_BY: 'Verificado por',
      NOT_VERIFY: 'No verificado',
      VERIFY: 'Verificado',
      LAST_VERIFICATION: 'Última verificación',
      LAST_MODIFICATION: 'Última modificación',
      MODIFIED_BY: 'Modificado por',
      PREVIEW: 'Vista Previa',
      LOADING: 'Cargando',
      COMPANIES: 'Sociedades',
      COMPANY: 'Sociedad',
      CONVERT_TO: "Convertir a Sociedad",
      VIEW: 'Ver detalle',
      EDIT: 'Editar',
      DELETE: 'Eliminar',
      SELECT: 'Seleccionar',
      USER: 'Usuario',
      DOCUMENT_TYPE: 'Tipo de documento',
      NAME: 'Nombre',
      LAST_NAME: 'Apellido',
      PHONE: 'Teléfono',
      EMAIL: 'Email',
      ACTIONS: 'Acciones',
      FOLDER: 'Carpeta',
      CREATE: 'Crear',
      EXPIRATION_DATE: 'Fecha de vencimiento',
      APPROVAL_DATE: 'Fecha de aprobación',
      FILING_DATE: 'Fecha de presentación',
      EXPIRATION_TYPE: 'Tipo de vencimiento',
      EXPIRATION_STATUS: 'Estado del vencimiento',
      EXPIRATION: 'Vencimiento',
      EXPIRATION_DOWNLOAD: 'Descargar vencimientos',
      AUTHORITY: 'Autoridad',
      DIRECTOR: 'Director',
      DIRECTORS: 'Directores',
      MANAGER: 'Gerente',
      MANAGERS: 'Gerentes',
      ADMIN: 'Administrador',
      ADMINS: 'Administradores',
      PRESIDENT: 'Presidente',
      VICEPRESIDENT: 'Vicepresidente',
      MANAGER_TIT: 'Gerente Titular',
      MANAGER_SUP: 'Gerente Suplente',
      ADMIN_TIT: 'Administrador Titular',
      ADMIN_SUP: 'Administrador Suplente',
      DIR_TIT: 'Director Titular',
      DIR_SUP: 'Director Suplente',
      SIND_TIT: 'Sindico Titular',
      SIND_SUP: 'Sindico Suplente',
      REP_LEG_TIT: 'Representante Legal Titular',
      REP_LEG_SUP: 'Representante Legal Suplente',
      SUBJECT: 'Sujeto',
      SUBJECTS: 'Sujetos',
      MEMBERS: 'Miembros',
      MEMBER: 'Miembro',
      TRUSTEE: 'Fideicomisario',
      FIDUCIARY: 'Fiduciario',
      OR_BENEF: 'Beneficiario originario',
      OR_TRUST: 'Fiduciante originario',
      ADHE_BENE: 'Beneficiario adherente',
      ADHE_TRUS: 'Fiduciante adherente',
      GENERAL_MANAGER: 'Gerente General',
      ALT_MANAGER: 'Gerente Suplente',
      SPEC_MANAGER: 'Gerente Especial',
      COMMISSARY: 'Comisario',
      ADMINISTRATOR: 'Administrador',
      INDEPENDENT_COUNSELOR: "Consejero Independiente",
      PATRIMONY_COUNSELOR: "Consejero Patrimonial",
      COUNSELOR: "Consejero",
      BOARD_SECRETARY: "Secretario del Consejo de Administración",
      NON_MEMBER_SECRETARY: "Secretario no miembro del consejo de Administración",
      VOWEL: 'Vocal',
      SECRETARY: 'Secretario',
      TREASURER: 'Tesorero',
      ADDNEW: '--AGREGAR NUEVO--',
      NEWAUTH: 'Nombre nueva autoridad',
      ADVISER: 'Consejero',
      TITULAR: 'Titular',
      SUPLENTE: 'Suplente',
      SUPLENTES: 'Suplentes',
      DENOMINATION: 'Denominación',
      PERSON: 'Persona',
      INDIVIDUALS: 'Personas Físicas',
      LEGAL_ENTITIES: 'Personas Jurídicas',
      BIRTH: 'Fecha de nacimiento',
      NATIONALITY: 'Nacionalidad',
      OCCUPATION: 'Profesión',
      MARITAL_STATUS: 'Estado civil',
      TITLE: 'Tratamiento',
      ID_TYPE: 'Tipo de documento',
      ID_NUMBER: 'Número de documento',
      PERSONAL_INFO: 'Datos de la persona',
      ADDITIONAL_INFO: 'Documento adicional',
      INSCRIPTION: 'Constancia de inscripción',
      STATUTE: 'Estatuto',
      LAST_INSCRIPTION: 'Última inscripción',
      ID_COPY: {
        AR: 'Copia de DNI/Pasaporte',
        CL: 'Copia de DNI/Pasaporte',
        PY: 'Copia de DNI/Pasaporte',
        UY: 'Copia de DNI/Pasaporte',
        US: 'Copia del ID card/Pasaporte',
        MX: 'Copia del ID card/Pasaporte',
        DF: 'Copia de DNI/Pasaporte',
      },
      NEW: 'nueva',
      OF: 'de',
      SHAREHOLDERS: 'Accionistas',
      SHAREHOLDER: 'Accionista',
      PARTNERS: 'Socios',
      PARTNER: 'Socio',
      LEGAL_REPRESENTATIVE: 'Representante legal',
      LEGAL_REPRESENTATIVES: 'Representantes legales',
      DOCUMENT: 'Documento',
      OPERATION_COUNTRIES: 'Paises de Operación',
      OPERATION_COUNTRY: 'País de Operación',
      NO_OPERATION_COUNTRIES: 'Esta Sociedad no tiene Países de Operación',
      NOT_APPLICABLE: 'No Aplica',
      NO_STATUS: 'Sin Estado',
      NO_TYPE: 'Sin Tipo',
      ATTACH_MAP: 'Adjuntar mapa societario',
      ATTACH_MAP_CL: 'Adjuntar malla societaria',
      INFORMATION: 'Información',
      NB_PUBLIC_REGISTRY: 'Nro. de inscripción Registro Público',
      NB_TAX_ID: 'Número de identificación fiscal',
      NB_TAX_ID_SHORT: 'Nro. de identificación fiscal',
      ART_REGISTRATION: 'Art. de inscripción',
      INFO_REGISTRATION_YEAR: 'Régimen informativo anual',
      CHOOSE_LINK: 'Elige el documento que quieras vincular',
      LINKED_DOCS_TITLE: 'Documentos vinculados',
      ADD_FROM_LIBRARY: 'Agregar de biblioteca',
      LINK_LIBRARY_HINT: 'Buscá un PDF de la biblioteca y vinculalo a este registro.',
      SEARCH_LIBRARY_PLACEHOLDER: 'Buscar en la biblioteca…',
      LINKING_AUTO_UPDATE: 'Al vincular o desvincular, el registro se actualiza automáticamente.',
      NO_LINKED_CTA: 'Agregá uno desde la biblioteca, más abajo.',
      OPEN_IN_NEW_TAB: 'Abrir en otra pestaña',
      UPLOAD_NEW_FILE: 'Cargar nuevo documento',
      UPLOAD_CONSTRAINTS_HINT:
        'Formatos soportados: {{formats}}. Peso máximo por subida: {{limit}}.',
      UPLOAD_FOLDER_EMPTY_HINT:
        'Las subcarpetas se replican con su estructura. Las subcarpetas vacías no se crean: si las necesitás, agregalas desde la Biblioteca.',
      UPLOAD_NEW_POA: 'Cargar nuevo poder',
      DETAIL_POA: "Detalle del Poder",
      SHARES: 'Acciones',
      SHARES_TYPES: 'Tipos de acciones',
      SHARES_CLASSES: 'Clases de acciones',
      QUOTAS: 'Cuotas',
      TOTALS: 'Totales',
      GENDER: 'El',
      QUESTION_ADD: 'La autoridad que desea agregar es',
      QUESTION_ADD_PERSON: '¿La persona que desea agregar es',
      QUESTION_ADD_LEGAL: '¿La autoridad que deseas agregar es una <b>Persona jurídica</b>?',
      LEGAL_ENTITY: 'Persona jurídica',
      SELECT_NEW: 'Seleccionar nueva autoridad',
      ADD_NEW: 'Añadir nueva',
      PERCENTAJE: 'Porcentaje',
      CAPITAL: 'Capital',
      FIXED_CAP: 'Capital social Fijo',
      VARIABLE_CAP: 'Capital social Variable',
      TOTAL_CAPITAL_STOCK: 'Capital Social Total',
      PROFESSIONAL: 'Profesional Responsable',
      CONTROL_BODIES: 'Organismos de control',
      ACTIVITY: 'Actividad',
      ACTIVITY_SII: 'Actividad y Código SII',
      SELECT_ACTIVITY: 'Seleccionar actividades',
      SELECT_CONTROL: 'Seleccionar organismo de control',
      DATE_INCORPORATION: 'Fecha de constitución',
      PAGES: 'Fojas',
      NUMBER: 'Número',
      YEAR: 'Año',
      SELECT_YEAR: 'Seleccione el año',
      REAL_STATE_CONSERVATIVE: 'Conservador Bienes Raices',
      PUBLICATION_EXTRACT:
        'Publicación extracto de constitución en el diario oficial',
      SUPERVISOR_BODY: 'Órgano supervisor',
      FANTASY_NAME: 'Nombre fantasía',
      COMMERCIAL_NUMBER: 'Nro de inscripción Registro de Comercio',
      INS_NUM_BANCO_CENTRAL_UY:
        'Número de inscripción al Banco Central de Uruguay',
      INS_NUM_BANCO_PREV_UY:
        'Número de inscripción al Banco de Previsión Social',
      DATE_BANCO_CENTRAL_UY:
        'Fecha de inscripción en el Banco Central de Uruguay',
      BOOK_CUSTODY: 'Custodia de libros',
      DENOMINATION_NAME: 'Denominación',
      PUBLIC_REGISTRY: 'Registro público',
      SAT_ACTIVITY: 'Actividad ante el SAT',
      IMSS: 'Registro patronal ante el IMSS',
      OWNERSHIP_PERCENTAJE: 'Participación',
      AMOUNT_SHARES: 'Acciones',
      ELEVATION_NUMBER: 'Número de elevación a escritura',
      POA_NAME: 'Nombre del Poder',
      GRANT_DATE: 'Fecha de otorgamiento',
      PROXIES_NAME: 'Nombre de los Apoderados',
      POWERS_CONFERRED: 'Facultades Otorgadas',
      PAID: 'Pagadas',
      FIXED_PORTION: 'Parte fija',
      VARIABLE_PORTION: 'Parte variable',
      AMOUNT_SOCIAL: 'Cantidad de cuotas sociales',
      NAME_LASTNAME: 'Nombre y apellido',
      POSITION: 'Cargo',
      TERM_EXPIRATION: 'Vencimiento de Mandato',
      DESIGNATION_DATE: 'Fecha de designación',
      COUNTRY: 'País',
      REPRESENTATIVE: 'Representante',
      APPOINTMENT_DATE: 'Fecha de nombramiento',
      POWER: 'Poder',
      POA_DETAILS: 'Detalle del poder',
      POA_TYPE: 'Tipo de poder',
      POA_INFORMATION: 'Información del poder',
      GENERAL_POA: 'Poder General',
      TYPE_GENERAL_POA: 'Tipo de poder general',
      SPECIAL_POA: 'Poder especial',
      TYPE_SPECIAL_POA: 'Tipo de poder especial',
      APPOINT_PROXIES: 'Designar Apoderados',
      SELECT_PROXIES: 'Seleccionar Apoderado',
      LIST_PROXIES: 'Lista de apoderados',
      SELECT_POWER: 'Seleccionar facultad',
      LIST_POWERS: 'Lista de facultades',
      NOTARY_REG_NUM: 'Número de registro notarial',
      FOLIO_NUMBER: 'Número de folio',
      FOLIO: 'Folio',
      NOTARY_REG: 'Reg. Not.',
      NOTARY_NAME: 'Nombre Notaría',
      NOTARY_PERSON: 'Nombre de notario',
      OBSERVATIONS: 'Observaciones',
      NO_OBSERVATIONS: 'Sin observaciones',
      FOLIO_NUM: 'Nº Folio',
      NOTARY_REG_NUMB: 'Nº registro notarial',
      REPERTOIRE_NUMBER: 'Numero de repertorio',
      DEED_NUM: 'Nro de escritura',
      DEED_NUMBER: 'Nro de escritura',
      DEED_DATE_MX: 'Fecha de escritura',
      DEED_NMB: 'Nro. de escritura',
      DEED_DATE: 'Fecha del acta',
      NOTARY_NUMBER: 'Número notario',
      POWERS: 'Poderes',
      LAST_DATE_REGIME: 'Última fecha de cumplimiento del Régimen informativo',
      TAX_ID_NUM: "Número de identificación tributaria",
      AMOUNT_OF: 'Cantidad de',
      BALANCE: 'Balance',
      APPROVAL: 'Aprobación',
      FILING: 'Presentacion',
      CONTRACT: 'Contrato',
      CONTRACT_TYPE: 'Tipo de contrato',
      OPEN_FIELD: 'Campo libre',
      ASSET_NAME: 'Nombre del bien',
      ASSET: 'Bien',
      VIEW_NAME: 'Nombre de vista',
      ROLE: 'Rol',
      EDIT_INFORMATION: 'Editar Información',
      PURPOSE: 'Objeto',
      REGISTERED_OFFICE: 'Domicilio Social',
      INF_ART_INCORPORATION: 'Información del acta constitutiva',
      USERNAME: 'Nombre del usuario',
      ENTRY_DATE: 'Fecha de alta',
      USER_TYPE: 'Tipo de usuario',
      INITIALS: 'Iniciales',
      SHARE_INFORMATION: 'Información Compartida',
      SIGN: 'Firmante',
      EDITOR: 'Editor',
      CLIENTE: 'Acceso Cliente',
      READ_ONLY: 'Solo lectura',
      SECURITY: 'Seguridad',
      LOGS: 'Logs',
      CLICKORDER: 'Click para ordenar',
      AVAILABLE_CAPITAL: 'Disponible',
      NEW_CLASS: 'Nueva Clase',
      UNDEFINED: 'Indefinido',
      FOLIO_MER:'Folio Mercantil',
      FIRMA_LIM: 'Firma y Límites',
      SIGNATURE: 'Firma',
      LIMITS: 'Limites',
      CLASS: 'Clase',
      NAME_GROUP: 'Nombre del Grupo',
      SHARED_SOC: 'Sociedades compartidas',
      SHOWMORE: 'Ver más',
      SHOWLESS: 'Ver menos',
      SEE_X_MORE: 'Ver {{count}} más',
      SEE_LESS: 'Ver menos',
      MINUTES_NUMBER: 'Nro de Acta',
      MINUTES_DATE: 'Fecha de Acta',
      ATTACH_INFO: 'Descargar Información Adicional',
      ATTACH_INFO_AD: 'Adjuntar Información Adicional',
      CAPITAL_AUTHORIZED: 'Capital Autorizado',
      CAPITAL_INTEGRATED: 'Capital Integrado',
      VOTE_VALUE: 'Votos por acción',
      MINUTES: 'Actas',
      MINUTES_TYPE: 'Tipo de acta',
      RESOLUTION: 'Resolución',
      BOOK: 'Libro',
      REGISTRY_FILE: 'Foja',
      TYPE_POWER: 'Tipo de poder',
      MEMBERS_COMITE: 'Miembros del comité',
      COMITE_NAME: 'Nombre del comité',
      COPY_TO_BOOK: 'Copiado a libro',
      SIGNATURES: 'Firmas',
      SIGN_ALL: 'Firman todos',
    },
    OPTIONS: {
      LAW_COL: 'Juicios y cobros',
      ADMIN_ACTS: 'Actas de administración',
      ADMIN_ACTS_LAB: 'Actas de administración en asuntos laborales',
      PROP_ACTS: 'Actas de propiedad',
      MODEL: 'Modelo',
    },
    MESSAGES: {
      PREVIEW_NOT_FOUND: 'Vista previa no encontrada',
      SUCCESS_MAP: 'Infornación adicional actualizada con éxito',
      ERROR_MAP: 'Ha ocurrido un error al actualizar mapa societario',
      DELETE_QUESTION: 'Estás seguro de que deseas eliminar',
      UNLINK_QUESTION: 'Estás seguro de que deseas desvincular',
      INACTIVE_QUESTION: '¿Estás seguro de que quieres desactivar la sociedad? Vas a poder volver a activarla cuando lo elijas.',
      ACTIVE_QUESTION: '¿Estás seguro de que quieres activar la sociedad?',
      DELETE_COMP_QUESTION: '¿Estás seguro de que quieres eliminar la sociedad seleccionada?',
      REMEMBER_DOC:
        'Recuerda subir a la biblioteca el documento que respalda este cambio.',
      SUCCESS_UPDATE: 'Se ha actualizado correctamente',
      ERROR_UPDATE: 'Ha ocurrido un error al actualizar',
      ERROR_INVALID: 'es un tipo de archivo no soportado',
      UPLOAD_INVALID_FORMAT:
        'No se puede subir por formato no soportado: {{files}}. Formatos soportados: {{formats}}.',
      UPLOAD_AND_N_MORE: 'y {{count}} más',
      UPLOAD_SIZE_EXCEEDED:
        'La carga supera el peso máximo por subida. Límite: {{limit}}. Peso de lo seleccionado: {{size}}. Quitá archivos o subí la carpeta en partes.',
      UPLOAD_BLOCKED_SIZE_TITLE_FOLDER: 'No es posible subir esta carpeta',
      UPLOAD_BLOCKED_SIZE_BODY_FOLDER:
        'La carpeta seleccionada pesa {{size}} y supera el máximo de {{limit}} por subida. Subila en partes o quitá archivos para continuar.',
      UPLOAD_BLOCKED_SIZE_TITLE_FILES: 'No es posible subir estos documentos',
      UPLOAD_BLOCKED_SIZE_BODY_FILES:
        'Lo seleccionado pesa {{size}} y supera el máximo de {{limit}} por subida. Subilo en tandas o quitá documentos para continuar.',
      MUST_SELECT_PROXY: 'Debe seleccionar al menos un apoderado',
      MUST_SELECT_POWER: 'Debe seleccionar al menos una facultad',
      POA_SAVED_SUCCESS: 'Poder guardado exitosamente.',
      POA_SAVED_DOC_LINKED: 'Poder guardado exitosamente y documento vinculado.',
      POA_SAVED_DOC_NOT_LINKED: 'Poder guardado exitosamente, documento no vinculado.',
      POA_CLONED_SUCCESS: 'Poder clonado exitosamente.',
      DELETE_POA_QUESTION: '¿Estás seguro de que deseas eliminar el poder?',
      DELETE_POA_DESCRIPTION: 'Recuerda subir a la Biblioteca el documento que respalda esta modificación.',
      BALANCE_DELETED_SUCCESS: 'Balance eliminado con éxito.',
      EXPIRATION_GENERATED: 'Vencimiento generado con éxito.',
      EXPIRATION_DELETED: 'Vencimiento eliminado con éxito.',
      COMPANY_DELETED: 'Sociedad eliminada con éxito.',
      EDIT_CONTRACT: 'Editar contrato',
      ADD_CONTRACT: 'Agregar nuevo contrato',
      EDIT_ASSET: 'Editar bien',
      ADD_ASSET: 'Agregar nuevo bien',
      EDIT_BALANCE: 'Editar balance',
      ADD_BALANCE: 'Agregar nuevo balance',
      DELETE_CONTRACT: '¿Estás seguro de que deseas eliminar el contrato?',
      USER_ADMIN:
        'Dirigido al dueño de la cuenta. Tiene acceso a toda la plataforma incluyendo administración de usuarios y pagos.',
      USER_SIGN:
        'Puede editar la información e iniciar documentos y aprobarlos, pero no puede agregar nuevos usuarios.',
      USER_EDIT:
        'Puede editar la información e iniciar documentos, pero no puede aprobarlos ni agregar nuevos usuarios.',
      USER_CLIENT:
        'Podrá ver toda la información y los documentos de la sociedad que se le compartan.',
      USER_READ_ONLY: 'Solo puede leer la información.',
      USER_IT: 'Acceso exclusivo al módulo de seguridad. Puede gestionar usuarios y administrar grupos, pero no accede a la información societaria.',
      USER_LOGS: 'Acceso exclusivo al módulo de Logs. Puede consultar el registro de actividad, pero no accede a la información societaria.',
      OK_DOC: "Documento actualizado correctamente",
      ERR_DOC: "Ha ocurrido un error al actualizar documento",
      ERR_GENERIC: "Ha ocurrido un error. Contacte al administrador",
      ERR_FOLDER: "No se pueden eliminar carpetas que contengan adentro documentos",
      EDIT_MINUTES: 'Editar acta',
      ADD_MINUTES: 'Agregar nuevo acta',
      DELETE_MINUTES: '¿Estás seguro de que deseas eliminar el acta?',
      EDIT_COMITE: 'Editar comité',
      ADD_COMITE: 'Agregar nuevo comité',
      NO_LINKED_FILES: 'No hay documentos vinculados',
      DOWNLOAD_TO_VIEW: 'Descargá el archivo para visualizarlo',
      ADMIN_DESCRIPTION: 'Creá grupos para organizar el acceso de los usuarios a las sociedades. Cada grupo define qué sociedades pueden ver y administrar sus miembros.',
      USERS_DESCRIPTION: 'Gestioná los usuarios de la plataforma. Creá nuevos accesos, editá información y administrá los roles de cada usuario.',
      NO_DOC_TYPES: 'No hay tipos de documentos disponibles para esa sociedad',
      NEED_PRESIDENT: 'Para aprobar un documento, la sociedad debe tener un presidente.',
      PRESS_HASH: 'Presioná # para ver las variables disponibles',
      UNUSED_VARS: 'Las siguientes variables no están siendo usadas:',
      SAVE_AS_MODEL: 'Se guardará como modelo predeterminado',
      SAVE_DOC_ONLY: 'Se guardará solo para este documento',
    },
    BUTTONS: {
      COPY: 'Copiar',
      SHARE_FOLDER: 'Compartir Carpeta',
      SHARE_DOC: 'Compartir Documento',
      CLEAN_FILTER: 'Limpiar Filtros',
      OPEN: 'Abrir',
      FILTER: 'Filtrar',
      FILTERS: 'Filtros',
      UPDATE: 'Actualizar',
      GO_TO_LIBRARY: 'Ir a la biblioteca',
      CORPORATE_SUMMARY: 'Ver Reporte',
      VERIFY: 'Verificar',
      SHARE: 'Compartir',
      ATTACH_DOCS: 'Documentos Vinculados',
      SEE_ATTACH_DOCS: 'Ver Documentos Vinculados',
      SAVE: 'Guardar',
      MODIFY: 'Modificar',
      NEXT: 'Siguiente',
      PREVIOUS: 'Anterior',
      CHANGE_COUNTRY: 'Cambiar de País',
      CLOSE: 'Cerrar',
      APPROVE: 'Aprobación de',
      FINALIZE: 'Finalizar trámite',
      EDIT_DOC: 'Editar documento',
      SAVE_PRINT: 'Guardar e imprimir borrador',
      SAVE_DRAFT: 'Guardar Borrador',
      NEW: 'Nuevo',
      NUEVA: 'Nueva',
      DOC: 'Documento',
      DOCS: 'Documentos',
      BY_DOC_NAME: 'Por nombre del documento',
      BY_FOLDER_NAME: 'Por nombre de carpeta',
      BY_CONTENT: 'Por contenido del documento',
      UPLOAD: 'Cargar',
      DELETE: 'Eliminar',
      DELETE_SELECTED: 'Eliminar seleccionados',
      MOVE_SELECTED: 'Mover seleccionados',
      DOWNLOAD: 'Descargar',
      DOWNLOAD_REPORTS: 'Descargar Reportes',
      MOVE_TO: 'Mover a',
      MOVE_FOLDER_TO: 'Mover a…',
      ADD: 'Agregar',
      ALL: 'Todos',
      CANCEL: 'Cancelar',
      RESOLVED: 'Resuelto',
      BACK: 'Volver',
      WHY_Q: '¿Por qué?',
      LINKAGES: 'Vinculaciones',
      FULL_VIEW: 'Vista Completa',
      LOCAL_VIEW: 'Vista Local',
      SAVE_VIEW: 'Guardar Vista',
      SEE: 'Ver Sociedad',
      LINK_FILE: 'Vincular Archivo',
      UNLINK: 'Desvincular',
      SEE_FILE: 'Ver Archivo',
      ADD_REP_LEG: 'Agregar Representante Legal',
      UPDATE_SHAREHOLDER: 'Editar accionista',
      EDIT: 'Editar',
      EDIT_POWER: 'Editar poder',
      ENTER: 'Ver poder',
      EDIT_PARTNER: 'Editar socio',
      LINK_FILES: 'Vincular documentos',
      GO_TO_UBICATION: 'Ir a la ubicacion del archivo',
      SAVE_CHANGES: 'Guardar cambios',
      CREATE_GROUP: 'Crear Grupos',
      CLONE: 'Clonar',
      COMITES: 'Comités',
      CLEAR_DATES: 'Limpiar fechas',
    },
    PLACEHOLDERS: {
      SEARCH: 'Buscar',
      USERS: 'Usuarios',
      SEARCH_USER: 'Buscar usuario',
      SEARCH_COMPANY: 'Buscar sociedad',
      SEARCH_BY_NAME: 'Buscar por Nombre',
      SEARCH_BY_LAST_NAME: 'Buscar por Apellido',
      FROM: 'Desde',
      TO: 'Hasta',
    },
    STATUTE: {
      DIRECTORY: 'Directorio',
      TERM_YEAR: 'Duración y ejercicio',
      TERM_COMPANY: 'Plazo de duración',
      YEAR_CLOSE: 'Cierre de ejercicio',
      COMPANY_EXPIRATION_DATE: 'Fecha de vencimiento de la sociedad',
      AUTHORITIES: 'Autoridades',
      INCUMBENT_DIR: 'Directores titulares',
      SUP_DIR: 'Directores suplentes',
      MAX_Q: 'Cantidad máxima',
      MIN_Q: 'Cantidad mínima',
      TERM_OFFICE: 'Plazo de duración de los cargos',
      OBJ: 'Objeto',
      OPEN_FIELD: 'Campo libre',
      NUM_DIC: 'Cantidad de directores',
      IND_TERM: 'Plazo Indeterminado',
      UNDET_NUM: 'Cantidad indeterminada de',
    },
    COMPANY_LIST: companyListES,
    SHARE_INFO_TABLE: ShareInfoTableES,
    DOC_FORMATION_TABLE: docFormationES,
    EXP_STUDIO_TABLE: expirationStudioES,
    IND: {
      NAME_LASTNAME: 'Nombre y Apellido',
      AUTHORITY: 'Autoridad',
      STOCK: 'Accionista',
      POWER: 'Apoderado',
      FULL_REPO: 'Reporte Completo',
      SHAREHOLDERS_REPO: 'Reporte Accionistas',
      FINAL_REPO: 'Reporte Beneficiarios Finales',
      ASK_TYPE_DOC: '¿Que informacion desea descargar?',
    },
    MENU: {
      LIBRARY: 'Biblioteca',
      CONTRACTS: 'Contratos',
      DOCUMENTS: 'Documentos',
      PERSONS: 'Personas',
      COMPANIES: 'Sociedades',
      TRAMITES: 'Trámites a Registar',
      EXPIRATIONS: 'Alertas y Vencimientos',
      SHAREINFO: 'Compartir Información',
      ADD: 'Crear Sociedad',
      CORPOTATE_MAP: 'Mapa Societario',
      ADMINISTRATION: 'Administración',
      SECTION_PRINCIPAL: 'Principal',
      SECTION_MANAGEMENT: 'Gestión',
      SECTION_SECURITY: 'Seguridad',
      SECTION_LOGS: 'Logs',
      USERS: 'Usuarios',
      LOGS: 'Logs',
    },
    CONTRACTS: {
      TITLE: 'Contratos',
      SEARCH_PLACEHOLDER: 'Buscar contrato, contraparte u objeto — Enter',
      SEARCH_HINT: 'Buscá y presioná Enter',
      CLEAR_SEARCH: 'Limpiar búsqueda',
      SEARCH_EMPTY: 'No se encontraron contratos para «{{term}}».',
      LOAD_NEW: 'Cargar Nuevo Contrato',
      ALERTS: 'Alertas',
      FILTER_EXPIRATIONS: 'Vencimientos',
      ALERT_HAS: 'Con alertas',
      ALERT_30: 'Vence en 30 días',
      ALERT_60: 'Vence en 60 días',
      COL_CONTRACT: 'Contrato',
      COL_TYPE: 'Tipo',
      COL_SOCIETY: 'Sociedad',
      COL_COUNTERPARTY: 'Contraparte',
      COL_PARTIES: 'Partes',
      COL_OBJECT: 'Objeto',
      COL_MONTO: 'Monto',
      // DEVS-421 — el listado y el árbol de contrapartes muestran el monto
      // VIGENTE (adendas aplicadas). El badge es corto porque la celda es angosta;
      // el tooltip explica y trae el valor anterior.
      MONTO_MODIFIED_BADGE: 'Adenda',
      MONTO_MODIFIED_TOOLTIP: 'Modificado por adenda. Antes: {{previous}}',
      COL_NEXT_EXPIRATIONS: 'Próximos vencimientos',
      COL_AUTO_RENEWAL: 'Renov. auto',
      COL_STATUS: 'Estado',
      COL_TAGS: 'Tags',
      // DEVS-424 — se unifica con el Portal, que ya dice "Vigente" para el
      // mismo `status: "active"` del API. Es solo la etiqueta: el valor del
      // contrato del API no cambia. Alcance: módulo Contratos únicamente —
      // "Activo" en otros módulos (usuarios, sociedades, poderes) significa
      // otra cosa y no se toca. EN ya coincide con el Portal ("Active").
      STATUS_ACTIVE: 'Vigente',
      STATUS_EXPIRING: 'Por vencer',
      STATUS_EXPIRED: 'Vencido',
      VIEW: 'Ver',
      YES: 'Sí',
      NO: 'No',
      VIEW_MODE: 'Vista',
      VIEW_LIST: 'Plano',
      VIEW_GROUPED: 'Agrupado por marco',
      FRAMEWORK: 'Marco',
      NO_FRAMEWORK: 'Contratos sin marco',
      OF_FRAMEWORK: 'de',
      GROUPED_EMPTY: 'No hay contratos para mostrar con los filtros aplicados.',
      FLAT_EMPTY: 'No hay contratos para mostrar con los filtros aplicados.',
      RESULTS_COUNT: '{{count}} contratos',
      GROUPS_COUNT: '{{count}} grupos',
      MARCOS_CONTRACTS_COUNT: '{{marcos}} marcos · {{contracts}} contratos',
      DELETE: {
        CONFIRM_TITLE: '¿Eliminar contrato?',
        IMPACT_INTRO: 'Al eliminar este contrato también se borrarán en cascada:',
        IMPACT_OUTRO: 'Esta acción no se puede deshacer.',
        SIMPLE: 'Esta acción no se puede deshacer.',
        AND: 'y',
        N_SUBCONTRACT: 'subcontrato',
        N_SUBCONTRACTS: 'subcontratos',
        N_ADDENDA: 'adenda',
        N_ADDENDAS: 'adendas',
        N_EXPIRATION: 'vencimiento',
        N_EXPIRATIONS: 'vencimientos',
        N_DOCUMENT: 'documento vinculado',
        N_DOCUMENTS: 'documentos vinculados',
        DELETED: 'Contrato eliminado.',
        DELETE_ERROR: 'No se pudo eliminar el contrato. Intentá de nuevo.',
      },
      FORM: {
        TITLE_NEW: 'Nuevo contrato',
        TITLE_EDIT: 'Editar contrato',
        TITLE_ADDENDA: 'Agregar adenda',
        SECTION_ADDENDA: 'Datos de la adenda',
        ADDENDA_HINT: 'La adenda es una copia editable de este contrato. Modificá lo que cambia y guardá; el contrato original no se altera.',
        ADDENDA_DATE: 'Fecha de la adenda',
        ADDENDA_DATE_REQUIRED: 'La fecha de la adenda es obligatoria.',
        DATE_INVALID: 'Fecha inválida. Usá el formato DD/MM/AAAA.',
        START_AFTER_END: 'El inicio de vigencia no puede ser posterior al vencimiento o a la terminación del contrato.',
        END_BEFORE_START: 'Esta fecha es anterior al inicio de vigencia.',
        ADDENDA_COMMENT: 'Comentario',
        ADDENDA_COMMENT_PLACEHOLDER: 'Describí brevemente qué cambia en esta adenda…',
        ADDENDA_COMMENT_REQUIRED: 'El comentario de la adenda es obligatorio.',
        ADDENDA_CREATED: 'Adenda creada.',
        SECTION_BASIC: 'Datos básicos',
        SECTION_PARTIES: 'Partes',
        SECTION_ECONOMICS: 'Económicos',
        SECTION_RENEWAL: 'Renovación',
        SECTION_EXPIRATIONS: 'Vencimientos adicionales',
        SECTION_DOCUMENT: 'Documento',
        SOCIETY: 'Sociedad',
        SOCIETY_PLACEHOLDER: 'Seleccioná la sociedad del contrato',
        SOCIETY_REQUIRED: 'La sociedad es obligatoria.',
        SOCIETY_INVALID: 'La sociedad seleccionada no es válida.',
        NAME: 'Nombre del contrato',
        NAME_PLACEHOLDER: 'Ej: Acuerdo marco distribución LATAM',
        NAME_REQUIRED: 'El nombre del contrato es obligatorio.',
        TYPE: 'Tipo',
        TYPE_PLACEHOLDER: 'Seleccioná un tipo',
        NO_TYPE: '— Sin tipo —',
        TAGS: 'Tags',
        TAGS_PLACEHOLDER: 'Escribí o seleccioná tags...',
        TAGS_HINT: 'Elegí tags existentes o escribí uno nuevo y presioná Enter para crearlo.',
        SIGNATURE_DATE: 'Fecha de firma',
        START_DATE: 'Inicio de vigencia',
        PARTY: 'Parte',
        PARTY_PLACEHOLDER: 'Buscar persona...',
        PARTY_HINT: 'Entidad propia o sociedad gestionada.',
        PARTY_IS_SOCIETY: 'La parte es la sociedad del contrato',
        PARTY_IS_SOCIETY_HINT: 'La parte del contrato es la sociedad vinculada',
        KIND_PERSON: 'Persona',
        KIND_SOCIETY: 'Sociedad',
        COUNTERPARTY: 'Contraparte',
        COUNTERPARTY_PLACEHOLDER: 'Buscar contraparte en el directorio...',
        COUNTERPARTY_HINT: 'Se busca primero en el directorio para no duplicar. Si no existe, la creás en el momento.',
        COUNTERPARTY_REQUIRED: 'La contraparte es obligatoria.',
        OBJECT: 'Objeto',
        OBJECT_PLACEHOLDER: 'Descripción del objeto contractual...',
        MONTO: 'Monto',
        MONTO_HINT: '"Monto" reemplaza a "Precio".',
        CURRENCY: 'Moneda',
        PERIODICITY: 'Periodicidad',
        PERIODICITY_PLACEHOLDER: 'Ej. Trimestral, bimestral…',
        PERIOD_MONTHLY: 'Mensual',
        PERIOD_BIMONTHLY: 'Bimestral',
        PERIOD_QUARTERLY: 'Trimestral',
        PERIOD_FOURMONTHLY: 'Cuatrimestral',
        PERIOD_BIANNUAL: 'Semestral',
        PERIOD_ANNUAL: 'Anual',
        PERIOD_ONE_TIME: 'Único',
        AUTO_RENEWAL: 'Renovación automática',
        NOTICE_PERIOD: 'Plazo de preaviso (días)',
        TERM_DUE_DAY: 'Día de vencimiento del plazo',
        SECTION_CLASSIFICATION: 'Clasificación',
        SECTION_COUNTERPARTY: 'Contraparte',
        SECTION_AMOUNT: 'Monto y periodicidad',
        SECTION_DATES: 'Fechas y Condiciones',
        PARENT_CONTRACT: 'Contrato Marco',
        PARENT_CONTRACT_PLACEHOLDER: 'Seleccioná un contrato marco/principal',
        PARENT_CONTRACT_NONE: '— Sin contrato marco —',
        BELONGS_TO: 'Pertenece a',
        PARENT_REQUIRED: 'Un subcontrato debe pertenecer a un contrato marco/principal.',
        PARENT_INVALID: 'El contrato marco seleccionado no es válido.',
        PARENT_NOT_ALLOWED: 'Un contrato marco/principal no puede pertenecer a otro contrato.',
        SOCIETIES: 'Sociedades de Brevity',
        ADD_SOCIETY: '+ Agregar sociedad…',
        TERMINATION_DATE: 'Fecha de terminación',
        TERMINATION_NOTICE: 'Aviso de terminación (días)',
        CP_NEW: 'Nueva contraparte',
        CP_TYPE: 'Tipo',
        CP_CLIENT: 'Cliente',
        CP_PROVIDER: 'Proveedor',
        CP_EMPLOYEE: 'Empleado',
        CP_PERSON: 'Persona',
        CP_PHYSICAL: 'Física',
        CP_LEGAL: 'Jurídica',
        CP_FIRST_NAME: 'Nombre',
        CP_LAST_NAME: 'Apellido',
        CP_DNI: 'DNI (opcional)',
        CP_DNI_PLACEHOLDER: 'Ej. 30123456',
        CP_LEGAL_NAME: 'Razón Social',
        CP_CUIT: 'CUIT (opcional)',
        CP_CUIT_PLACEHOLDER: 'Ej. 30-12345678-9',
        CP_CREATE_USE: 'Crear y usar',
        CP_REQUIRED: 'Completá los datos obligatorios de la contraparte.',
        CP_CREATED: 'Contraparte creada.',
        CP_CREATE_ERROR: 'No se pudo crear la contraparte. Intentá de nuevo.',
        EXPIRATIONS_HINT: 'Ajustes tarifarios, revisiones técnicas, hitos de pago u otros recordatorios asociados al contrato.',
        EXP_LABEL: 'Etiqueta',
        EXP_LABEL_PLACEHOLDER: 'Ej: Ajuste tarifario',
        EXP_DATE: 'Fecha',
        EXP_NOTICE: 'Preaviso (días)',
        ADD_EXPIRATION: 'Agregar vencimiento',
        PDF: 'Archivo PDF firmado',
        PDF_PLACEHOLDER: 'Seleccionar archivo PDF',
        DOCUMENT: 'Documento vinculado',
        LINK_DOCUMENT: 'Vincular documento de la biblioteca',
        LINK_DOCUMENT_HINT: 'Abre la biblioteca de la sociedad para elegir un documento existente.',
        SAVE_BEFORE_LINK: 'Completá los datos obligatorios; el contrato se guarda antes de vincular el documento.',
        CREATED: 'Contrato creado.',
        UPDATED: 'Cambios guardados.',
        SAVE_ERROR: 'No se pudo guardar el contrato. Intentá de nuevo.',
        FILE_ERROR: 'El contrato se guardó, pero falló la carga del PDF.',
        TAG_CREATE_ERROR: 'No se pudo crear el tag.',
        TAG_DELETE: 'Eliminar tag',
        TAG_DELETE_CONFIRM:
          '¿Eliminar este tag? Se borrará del catálogo y se desvinculará de todos los contratos.',
        TAG_DELETED: 'Tag eliminado.',
        TAG_DELETE_ERROR: 'No se pudo eliminar el tag. Intentá de nuevo.',
        TAG_DELETE_NOT_FOUND: 'El tag ya no existe.',
        TAG_DELETE_NOT_OWNER: 'No podés eliminar un tag que no es propio.',
      },
      DETAIL: {
        BACK: 'Volver a contratos',
        NOT_FOUND: 'No se encontró el contrato.',
        DOWNLOAD_PDF: 'Descargar PDF',
        OPEN_IN_NEW_TAB: 'Abrir en pestaña nueva',
        OWNER: 'Responsable',
        NO_OWNER: '— sin asignar —',
        OWNER_EDIT: 'Cambiar responsable',
        OWNER_PLACEHOLDER: 'Seleccioná un responsable',
        OWNER_REQUIRED: 'Seleccioná un responsable.',
        OWNER_UPDATED: 'Responsable actualizado.',
        OWNER_INVALID: 'El usuario seleccionado no puede ser responsable.',
        OWNER_ERROR: 'No se pudo actualizar el responsable. Intentá de nuevo.',
        TAB_GENERAL: 'Información general',
        TAB_EXPIRATIONS: 'Vencimientos',
        TAB_DOCUMENTS: 'Documentos vinculados',
        TAB_HISTORY: 'Historial',
        SOCIETY: 'Sociedad asociada',
        NO_SOCIETY: '— sin vincular —',
        BELONGS_TO: 'Pertenece a',
        PARENT_FALLBACK: 'Contrato marco',
        SUBCONTRACTS: 'Subcontratos',
        NO_SUBCONTRACTS: 'Este contrato no tiene subcontratos.',
        NEW_SUBCONTRACT: 'Nuevo subcontrato',
        ADD_ADDENDA: 'Agregar adenda',
        ADDENDAS: 'Adendas',
        OPEN_DOCUMENT: 'Ver documento',
        EDIT_ADDENDA: 'Editar adenda',
        DELETE_ADDENDA: 'Eliminar adenda',
        ADDENDA_DELETE_CONFIRM: '¿Eliminar esta adenda? Los campos que modificaba vuelven a su valor original.',
        ADDENDA_DELETED: 'Adenda eliminada.',
        ADDENDA_DELETE_ERROR: 'No se pudo eliminar la adenda. Intentá de nuevo.',
        ADDENDA_UPDATED: 'Adenda actualizada.',
        MODIFIED_BY_ADDENDA: 'Modificado por adenda #{{n}}',
        CURRENT_VALUE: 'Estado vigente',
        NOTES: 'Notas',
        EXPIRATIONS_TITLE: 'Vencimientos del contrato',
        TERM_EXPIRATION: 'Vencimiento de plazo',
        TERMINATION_DATE: 'Fecha de terminación',
        EXPIRATION_DATE: 'Vencimiento',
        NO_EXPIRATIONS: 'Este contrato no tiene vencimientos registrados.',
        STATE_ACTION_REQUIRED: 'Acción requerida',
        STATE_UPCOMING: 'Próximo',
        STATE_SCHEDULED: 'Programado',
        STATE_FINAL: 'Plazo final',
        OVERDUE_DAYS: 'vencido hace {{days}} días',
        IN_DAYS: 'en {{days}} días',
        DUE_TODAY: 'vence hoy',
        EXP_REQUIRED: 'Completá la etiqueta y la fecha del vencimiento.',
        EXP_LABEL_REQUIRED: 'La etiqueta es obligatoria.',
        EXP_DATE_REQUIRED: 'La fecha es obligatoria.',
        INCONSISTENT_DATES: 'Fechas inconsistentes',
        INCONSISTENT_DATES_HINT: 'El inicio de vigencia de este contrato es posterior a su vencimiento o terminación. Revisá y corregí las fechas desde Editar.',
        EXP_ADDED: 'Vencimiento agregado.',
        EXP_ERROR: 'No se pudo agregar el vencimiento. Intentá de nuevo.',
        // DEVS-405 — motivos concretos del endpoint dedicado de vencimientos.
        EXP_ERROR_NOT_FOUND: 'No se encontró el contrato. Puede haber sido eliminado; recargá la página.',
        EXP_ERROR_INVALID_DATE: 'La fecha del vencimiento no es válida.',
        EXP_ERROR_EXPIRATION_NOT_FOUND: 'No se encontró el vencimiento. Puede haber sido eliminado; recargá la página.',
        MANAGE_DOCS: 'Gestionar documentos',
        OPEN_LIBRARY: 'Abrir biblioteca',
        HAS_DOCS: 'Este contrato tiene documentos vinculados.',
        NO_DOCS: 'Este contrato no tiene documentos vinculados todavía.',
        NO_FILES: 'No hay PDF disponible para descargar. Vinculá un documento desde la biblioteca.',
        HISTORY_EMPTY: 'El historial de cambios aún no está disponible para contratos.',
      },
      HISTORY: {
        VIEW_CHANGES: 'Registro de cambios',
        VIEW_SECTIONS: 'Secciones',
        VIEW_TIMELINE: 'Línea de tiempo',
        CURRENT_STATE: 'Estado vigente',
        NO_STATE: 'No hay datos de estado vigente para este contrato.',
        CHANGELOG: 'Registro de cambios',
        ADDENDAS: 'Adendas',
        ADDENDA_N: 'Adenda #{{n}}',
        OPEN_DOCUMENT: 'Ver documento',
        DOCUMENT: 'Documento',
        NO_FIELD_CHANGES: 'Esta adenda no modificó ningún campo.',
        NO_ADDENDAS: 'Este contrato no tiene adendas.',
        NO_EVENTS: 'Este contrato no tiene eventos en su historial.',
        EVENT_SIGNATURE: 'Firma del contrato',
        EVENT_ADDENDA: 'Adenda',
        EVENT_ADDENDA_N: 'Adenda #{{n}}',
        EVENT_EXPIRATION: 'Vencimiento del contrato',
        FIELD_MONTO: 'Monto',
        FIELD_PERIODICITY: 'Periodicidad',
        FIELD_CURRENCY: 'Moneda',
        FIELD_EXPIRATION: 'Vencimiento',
        FIELD_SIGNATURE: 'Fecha de firma',
        FIELD_START: 'Inicio de vigencia',
        FIELD_TERMINATION: 'Fecha de terminación',
        FIELD_COUNTERPARTY: 'Contraparte',
        FIELD_SOCIETIES: 'Partes',
        FIELD_AUTO_RENEWAL: 'Renovación automática',
        FIELD_TERMINATION_NOTICE: 'Aviso de terminación (días)',
      },
    },
    COUNTERPARTIES: {
      TITLE: 'Contrapartes',
      BACK_TO_CONTRACTS: 'Volver a contratos',
      BACK_TO_LIST: 'Volver a contrapartes',
      SEARCH_PLACEHOLDER: 'Buscar por nombre, razón social o documento...',
      LOAD_NEW: 'Nueva contraparte',
      COL_NAME: 'Nombre',
      COL_TYPE: 'Tipo',
      COL_PERSON_TYPE: 'Naturaleza',
      COL_DOCUMENT: 'Documento',
      COL_LINKED_CONTRACTS: 'Contratos vinculados',
      DELETE_HAS_CONTRACTS: 'No se puede eliminar: la contraparte tiene contratos vinculados.',
      TYPE_CLIENTE: 'Cliente',
      TYPE_PROVEEDOR: 'Proveedor',
      TYPE_EMPLEADO: 'Empleado',
      PERSON_FISICA: 'Física',
      PERSON_JURIDICA: 'Jurídica',
      NO_TYPE: '— sin tipo —',
      NO_PERSON_TYPE: '— sin naturaleza —',
      REQUIRED: 'Completá los datos obligatorios de la contraparte.',
      CREATED: 'Contraparte creada.',
      UPDATED: 'Cambios guardados.',
      SAVE_ERROR: 'No se pudo guardar la contraparte. Intentá de nuevo.',
      LEGAL_NAME_REQUIRED: 'La razón social es obligatoria.',
      INVALID_TYPE: 'El tipo seleccionado no es válido.',
      INVALID_PERSON_TYPE: 'La naturaleza seleccionada no es válida.',
      DELETE_CONFIRM: '¿Está seguro que desea eliminar esta contraparte?',
      DELETED: 'Contraparte eliminada.',
      DELETE_ERROR: 'No se pudo eliminar la contraparte. Intentá de nuevo.',
      FORM: {
        TITLE_NEW: 'Nueva contraparte',
        TITLE_EDIT: 'Editar contraparte',
        SECTION_DATA: 'Datos de la contraparte',
        TYPE: 'Tipo',
        PERSON_TYPE: 'Naturaleza',
        FIRST_NAME: 'Nombre',
        LAST_NAME: 'Apellido',
        DNI: 'DNI (opcional)',
        DNI_PLACEHOLDER: 'Ej. 30123456',
        LEGAL_NAME: 'Razón Social',
        CUIT: 'CUIT (opcional)',
        CUIT_PLACEHOLDER: 'Ej. 30-12345678-9',
        DNI_SHORT: 'DNI',
        CUIT_SHORT: 'CUIT',
      },
      DETAIL: {
        LINKED_CONTRACTS: 'Contratos vinculados',
        NO_CONTRACTS: 'Esta contraparte no tiene contratos vinculados.',
        NOT_FOUND: 'No se encontró la contraparte.',
      },
    },
    PROFILE: {
      LOGOUT: 'Salir',
      USERS_SETTINGS: 'Configuración de usuarios',
    },
    ALERTS: {
      TAB_MY_CALENDAR: 'Mi calendario',
      TAB_EXPIRATIONS: 'Vencimientos',
      TAB_SETTINGS: 'Configuración',
      SETTINGS: {
        TITLE: 'Configuración de alertas por tipo',
        LEAD: 'Configurá cuántos días antes querés recibir avisos para cada tipo de vencimiento. Estas anticipaciones se aplican a todos tus vencimientos, salvo que personalices uno en particular desde la pantalla de ese vencimiento.',
        SYNC_NOTE: 'Los cambios se reflejarán en tu calendario en la próxima sincronización (Google Calendar puede tardar hasta 24h).',
        CHIPS_LABEL: 'Anticipaciones (días antes del vencimiento)',
        EMPTY_TYPE: 'Sin recordatorios para este tipo.',
        SUSTAINED_TOGGLE: 'Recordatorio sostenido (últimos 5 días)',
        SUSTAINED_HINT: 'Cuando se activa, recibís un aviso por día en los 5 días previos al vencimiento.',
        TYPE_CONTRACT: 'Contratos',
        TYPE_POWER: 'Poderes',
        TYPE_AUTHORITY: 'Autoridades',
        TYPE_BALANCE: 'Balances',
        TYPE_CUSTOM: 'Alertas personalizadas',
        SAVED: 'Configuración guardada.',
        ERROR_LOAD: 'No se pudo cargar la configuración.',
        ERROR_SAVE: 'No se pudo guardar la configuración. Intentá de nuevo.',
      },
      ONBOARDING: {
        BANNER_TITLE: 'Llevá tus vencimientos a tu calendario',
        BANNER_TEXT: 'Suscribite al feed de Brevity y recibí avisos en Google Calendar, Outlook o Apple Calendar.',
        BTN_SUBSCRIBE: 'Suscribirme',
        BTN_SNOOZE: 'Recordame después',
        BTN_DISMISS: 'No mostrarme más',
        MODAL_TITLE: 'Suscribí tu calendario al feed de Brevity',
        MODAL_LEAD: 'Generá tu URL personal y suscribila en tu cliente de calendario. Vas a ver cada vencimiento como evento de día completo.',
        MODAL_GENERATE_HINT: 'Todavía no generaste tu URL personal. Hacelo con un click — vas a poder regenerarla en cualquier momento desde tu perfil.',
        MODAL_GENERATE_BUTTON: 'Generar mi URL',
        TAB_GOOGLE: 'Google Calendar',
        TAB_OUTLOOK: 'Outlook',
        TAB_APPLE: 'Apple Calendar',
        STEP_GOOGLE_1: 'Abrí Google Calendar en tu navegador.',
        STEP_GOOGLE_2: 'En el panel izquierdo, hacé click en el "+" al lado de "Otros calendarios".',
        STEP_GOOGLE_3: 'Elegí "Desde URL" y pegá la URL que copiaste.',
        STEP_GOOGLE_4: 'Hacé click en "Añadir calendario". Los vencimientos aparecen en unos minutos.',
        STEP_OUTLOOK_1: 'Abrí Outlook web (outlook.live.com).',
        STEP_OUTLOOK_2: 'En el sidebar, hacé click en "Agregar calendario" → "Suscribirse desde la web".',
        STEP_OUTLOOK_3: 'Pegá la URL y dale un nombre al calendario.',
        STEP_OUTLOOK_4: 'Confirmá. Outlook sincroniza el feed automáticamente.',
        STEP_APPLE_1: 'En Apple Calendar, abrí el menú "Archivo".',
        STEP_APPLE_2: 'Elegí "Nueva suscripción de calendario" y pegá la URL.',
        STEP_APPLE_3: 'Configurá la frecuencia de actualización y confirmá.',
        SYNC_NOTE: 'Tu calendario se actualiza solo, pero los cambios pueden tardar hasta 24h en aparecer. Google Calendar sincroniza feeds una vez por día.',
        SNACK_COPIED: 'URL copiada al portapapeles.',
        ERROR_GENERATE: 'No se pudo generar la URL. Intentá de nuevo.',
        ERROR_GENERIC: 'No se pudo guardar la acción. Intentá de nuevo.',
      },
      LOADING: 'Cargando…',
      EMPTY_TITLE: 'Suscribí tus vencimientos a tu calendario',
      EMPTY_DESCRIPTION: 'Generá una URL personal para suscribir tus vencimientos de Brevity en Google Calendar, Outlook o Apple Calendar. Vas a ver cada vencimiento como evento de día completo, con un aviso 20 y 10 días antes.',
      GENERATE_BUTTON: 'Generar mi URL de calendario',
      READY_TITLE: 'Tu calendario está listo',
      READY_DESCRIPTION: 'Copiá esta URL y agregala en tu cliente de calendario como "Suscribir por URL". Vas a ver los vencimientos de las sociedades a las que tenés acceso.',
      REGENERATE_BUTTON: 'Regenerar URL',
      SYNC_NOTE: 'Tu calendario se actualiza solo, pero los cambios pueden tardar hasta 24 horas en aparecer. Google Calendar y Outlook sincronizan feeds suscriptos una vez por día — no hay forma de forzar la actualización desde Brevity.',
      HOW_TO_TITLE: 'Cómo suscribirla en tu calendario',
      HOWTO_GOOGLE: 'En Google Calendar: Configuración → Agregar calendario → Desde URL → Pegá la URL.',
      HOWTO_OUTLOOK: 'En Outlook web: Calendario → Agregar calendario → Suscribirse desde la web → Pegá la URL.',
      HOWTO_APPLE: 'En Apple Calendar: Archivo → Nueva suscripción de calendario → Pegá la URL.',
      MODAL_REGENERATE_TITLE: 'Regenerar URL del calendario',
      MODAL_REGENERATE_DESCRIPTION: 'Si regenerás, la URL anterior dejará de funcionar. Vas a tener que volver a suscribirte en tu calendario con la URL nueva. ¿Continuar?',
      SNACK_GENERATED: 'URL generada. Copiala y suscribila en tu calendario.',
      SNACK_REGENERATED: 'URL regenerada. La anterior ya no funciona.',
      SNACK_COPIED: 'URL copiada al portapapeles',
      ERROR_LOAD: 'No se pudo cargar el estado de tu URL de calendario.',
      ERROR_GENERIC: 'Ocurrió un error. Intentá de nuevo.',
    },
    MOVE_FOLDER: {
      TITLE: 'Mover carpeta',
      CURRENT_LOCATION: 'Ubicación actual',
      CONFIRM_TITLE: '¿Mover carpeta?',
      CONFIRM_DESCRIPTION: 'Vas a mover <b>{{name}}</b> a <b>{{destination}}</b>.',
      MOVING: 'Moviendo carpeta',
      SUCCESS: 'Carpeta movida',
      ERROR_TITLE: 'No es posible realizar esta operación',
      ERRORS: {
        name_conflict: 'Ya existe una carpeta con ese nombre en el destino.',
        destination_inside_source: 'No se puede mover una carpeta dentro de sí misma o de una de sus subcarpetas.',
        same_location: 'La carpeta ya está en esa ubicación.',
        different_company: 'Solo se puede mover dentro de la misma sociedad.',
        cannot_move_root: 'La carpeta raíz de la sociedad no se puede mover.',
        destination_not_found: 'La carpeta ya no existe. Actualizá la vista.',
        folder_not_found: 'La carpeta ya no existe. Actualizá la vista.',
        forbidden: 'No tenés permisos para mover esta carpeta.',
        technical_error: 'Ocurrió un error y no se aplicó ningún cambio. Intentá de nuevo.',
      },
    },
    TABLES: {
      EMPTY: 'No hay registros',
    },
    TEXT: {
      YES: 'Si',
      NO: 'No',
      ADV_SEARCH: 'Busqueda Avanzada',
      CHOOSE_COUNTRY_SIMPLE: 'Seleccione el país de la sociedad',
      CHOOSE_COMPANY: 'Seleccione una sociedad',
      CHOOSE_COUNTRY: 'Elija el país correspondiente a la sociedad',
      CHOOSE_COUNTRY_ALL: 'Todos los países',
      CHOOSE_ADMIN_GROUP: 'Elija el grupo de administración para la sociedad',
      ADD_CUSTOM_EXPIRATION: 'Agregar vencimiento personalizado',
      EDIT_CUSTOM_EXPIRATION: 'Editar vencimiento personalizado',
      INVALID_SELECTION: 'Seleccion inválida',
      SURE_TO_DELETE: '¿Seguro deseas eliminar el vencimiento?',
      SURE_TO_DELETE_GROUP: '¿Seguro desea eliminar el Grupo?',
      SELECT_MODULE_ERROR: 'Seleccione al menos un módulo',
      POLITICALLY_EXPOSED: 'Persona políticamente expuesta',
      CHOOSE_DOC_TYPE: 'Seleccione el tipo de documento',
      CHOOSE_FOLDER_NAME: 'Seleccione una carpeta',
      MOVE_FILE: 'Mover Archivo',
      MOVE_FILES: 'Mover Archivos',
      NEW_FOLDER: 'Nueva Carpeta',
      MOVE: 'Mover',
      MOVE_HERE: 'Mover Aqui',
      MOVING_FILES: 'Moviendo archivos',
      OF: 'de',
      RENAME_FOLDER: 'Renombrar Carpeta',
      NEW_FOLDER_NAME: 'Nuevo nombre de Carpeta',
      CHOOSE_FAC: 'Seleccionar Facultad',
      CHOOSE_IND: 'Seleccionar Apoderado',
      POWERS: 'Facultades',
      IND: 'Apoderados',
    },
    VALIDATION_MESSAGES: {
      MAX_PERM: "El máximo permitido es ",
      MAX_2: "El máximo de caracteres es 2",
      MAX_20: "El máximo de caracteres es 20",
      MAX_30: "El máximo de caracteres es 30",
      MAX_40: "El máximo de caracteres es 40",
      MAX_100: "El máximo de caracteres es 100",
      MAX_150: "El máximo de caracteres es 150",
      MAX_500: "El máximo de caracteres es 500",
      MAX_10000: "El máximo de caracteres es 10000",
      
      MAX_DIG_2: "El máximo permitido es de 2 dígitos",
      MAX_DIG_30: "El máximo permitido es de 30 dígitos",
      MAX_DIG_100: "El máximo permitido es de 100 dígitos",
      
      MIN_DIG_0: "El número mínimo es 0",
      MIN_NUM_1: "El número mínimo es 1",
      MIN_0_0000000001: "El mínimo permitido es 0.0000000001",
      
      MAX_NUM_100: "El número máximo es 100",
      MAX_NUM_999: "El número máximo es 999",
      MAX_NUM_1000: "El número máximo es 1000",
      
      WHITE_SPACE: "No puede ingresar solo espacios en blanco",
      REQUIRED_FIELD: "Campo obligatorio",
      SEL_FIR: "Seleccione un tipo de firma",
      SEL_CAR: "Seleccione un cargo",
      
      SOLO_NUM_GUION: "Solo puede ingresar números y guiones",
      NUM_INV: "Número inválido",
      
      FEC_OTOR: "La fecha de otorgamiento no puede ser posterior a la expiración",
      FEC_EXP: "La fecha de expiración no puede ser anterior al otorgamiento"      
    },
    POA: {
      INDISTINCT: "Indistinta",
      INDIVIDUAL: "Individual",
      JOINT: "Conjunta"
    },
    // SETTING BY COUNTRY CODE
    BY_COUNTRY: {
      AR: {
        AUTHORITY: {
          REPRESENTATIVE: 'Asignar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'Número de Documento',
          LEGAL_DOCUMENT_TYPE: 'CUIT/CUIL',
          STREET: 'Dirección',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          DEPARTMENT: 'Departamento',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Dirección',
          TYPE: 'Sede Social',
          FOREING: 'Domicilio Local',
          PROVINCE: 'Provincia',
          LOCATION: 'Localidad',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FOREING_ADDRESS: 'Domicilio extranjero',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
      DF: {
        AUTHORITY: {
          REPRESENTATIVE: 'Asignar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'Número de Documento',
          LEGAL_DOCUMENT_TYPE: 'CUIT',
          STREET: 'Dirección',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          DEPARTMENT: 'Departamento',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Dirección',
          TYPE: 'Sede Social',
          FOREING: 'Domicilio Local',
          FOREING_ADDRESS: 'Domicilio',
          PROVINCE: 'Provincia',
          LOCATION: 'Localidad',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
      CL: {
        AUTHORITY: {
          REPRESENTATIVE: 'Designar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUT',
          LEGAL_DOCUMENT_TYPE: 'RUT',
          STREET: 'Dirección',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Domicilio',
          TYPE: 'Sede Social',
          FOREING: 'Domicilio local',
          PROVINCE: 'Provincia',
          LOCATION: 'Comuna',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FOREING_ADDRESS: 'Domicilio extranjero',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
      PY: {
        AUTHORITY: {
          REPRESENTATIVE: 'Designar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUC',
          LEGAL_DOCUMENT_TYPE: 'RUC',
          STREET: 'Calle',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          DEPARTMENT: 'Departamento',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Calle',
          TYPE: 'Domicilio',
          FOREING: 'Domicilio Local',
          PROVINCE: 'Departamento',
          LOCATION: 'Ciudad',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FOREING_ADDRESS: 'Domicilio extranjero',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
      US: {
        INFO: {
          DOCUMENT_TYPE: 'TAX number',
          FILLING_NUMBER: 'Filling Number',
          REGISTERED_AGENT: 'Registered Agent',
        },
        AUTHORITY: {
          REPRESENTATIVE: 'Designar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'ID Card',
          LEGAL_DOCUMENT_TYPE: 'ID Card',
          STREET: 'Street',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Domicilio',
          TYPE: 'Sede Social',
          FOREING_ADDRESS: 'Domicilio extranjero',
          PROVINCE: 'Provincia',
          LOCATION: 'Comuna',
          FOREING: 'Domicilio local',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
      UY: {
        AUTHORITY: {
          REPRESENTATIVE: 'Designar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUT',
          LEGAL_DOCUMENT_TYPE: 'RUT',
          STREET: 'Dirección',
          FLOOR: 'No. de puerta',
          ADDRESS_NUMBER: 'No. de apartamento',
          DEPARTMENT: 'Departamento',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Domicilio',
          TYPE: 'Domicilio',
          FOREING: 'Domicilio',
          PROVINCE: 'Departamento',
          LOCATION: 'Localidad',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          FOREING_ADDRESS: 'Domicilio extranjero',
          STREET: 'Calle',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
          DOOR: 'No. de puerta',
          APARTMENT: 'No. de apartamento',
        },
      },
      MX: {
        AUTHORITY: {
          REPRESENTATIVE: 'Asignar Apoderados',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'Número de Documento',
          LEGAL_DOCUMENT_TYPE: 'Número de identificación fiscal',
          STREET: 'Dirección',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          DEPARTMENT: 'Departamento',
        },
        UBICATION: {
          POSTAL_CODE: 'Código postal',
          ADDRESS: 'Dirección',
          TYPE: 'Sede Social',
          FOREING: 'Domicilio Local',
          PROVINCE: 'Provincia',
          LOCATION: 'Localidad',
          FIDEICOMISO_DOM: 'Domicilio',
          FIDEICOMISO: 'Ubicación del fideicomiso',
          TAX_ADDRESS: 'Domicilio Fiscal',
          FOREING_ADDRESS: 'Domicilio Fiscal',
          STREET: 'Calle',
          FLOOR: 'Piso',
          ADDRESS_NUMBER: 'Número',
          OFFICE_NUMBER: 'No. de oficina',
        },
      },
    },
    LOGS: {
      DATE_FROM: "Desde",
      DATE_TO: "Hasta",
      USERS: "Usuarios",
      DATE: "Fecha",
      EMAIL: "Usuario",
      TYPE: "Tipo",
      DETAIL: "Detalles",
      DETAIL2: "Detalles",
      EXPORT: "Descargar"
    },
    USERS: {
      EXPORT: "Exportar CSV",
      SEARCH_PLACEHOLDER: "Buscar usuarios"
    },
    MARITAL_STATUS: {
      CASADO: "Casado/a",
      SOLTERO: "Soltero/a",
      DIVORCIADO: "Divorciado/a",
      VIUDO: "Viudo/a",
      UNION: "Unión Convivencial"
    },
    PAGINATOR: {
      ITEMS_PER_PAGE: "Items por página",
      NEXT_PAGE: "Página siguiente",
      PREVIOUS_PAGE: "Página anterior",
      FIRST_PAGE: "Primera página",
      LAST_PAGE: "Última página",
      OF: "de"
    }
  }
};
